var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevroneLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.725 12.0001L17.075 19.3501C17.325 19.6001 17.4458 19.8918 17.4375 20.2251C17.4292 20.5584 17.3 20.8501 17.05 21.1001C16.8 21.3501 16.5083 21.4751 16.175 21.4751C15.8417 21.4751 15.55 21.3501 15.3 21.1001L7.6 13.4251C7.4 13.2251 7.25 13.0001 7.15 12.7501C7.05 12.5001 7 12.2501 7 12.0001C7 11.7501 7.05 11.5001 7.15 11.2501C7.25 11.0001 7.4 10.7751 7.6 10.5751L15.3 2.87511C15.55 2.62511 15.8458 2.50428 16.1875 2.51261C16.5292 2.52094 16.825 2.65011 17.075 2.90011C17.325 3.15011 17.45 3.44178 17.45 3.77511C17.45 4.10844 17.325 4.40011 17.075 4.65011L9.725 12.0001Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevroneLeft);
export default __webpack_public_path__ + "static/media/ChevroneLeft.28ec64a2.svg";
export { ForwardRef as ReactComponent };